import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@paypalcorp/pp-react';
import { localsMessages } from '../../utility/getTemplateData';

const { button } = localsMessages('common/header');
const className = 'sign_up_alert';

const SignUpAlert = (props) => {
  const [hideAlert, setHideAlert] = useState(false);

  const handleCloseButton = () => {
    setHideAlert(true);
  };
  if (props.signUpStatus && !hideAlert) {
    return (
      <Alert
        id="signUpAlert"
        type="success"
        className={className}
        closeButtonLabel={button.close}
        closeButton={{
          onClick: handleCloseButton,
        }}
      >
        {props.successMessage}
      </Alert>
    );
  }

  return (
    <>
      {!hideAlert && (
        <Alert
          id="signUpAlert"
          type="info"
          className={className}
          closeButtonLabel={button.close}
          closeButton={{
            onClick: handleCloseButton,
          }}
        >
          {props.failMessage}
        </Alert>
      )}
    </>
  );
};

SignUpAlert.propTypes = {
  signUpStatus: PropTypes.bool,
  successMessage: PropTypes.string,
  failMessage: PropTypes.string,
};

export default SignUpAlert;
